import { UseQueryResult } from "react-query";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { RemoteApiError } from "../useRemote/types";
import { VehicleBookingEventDto } from "../../../components/FleetManagement/types/FleetManagement-row.types";

export type BookingEventsCalendarParams = {
  vehicleIds: number[];
  startDate: string; // ISO date (YYYY-MM-DD)
  endDate: string; // ISO date (YYYY-MM-DD)
};

/**
 * Fetches booking events for calendar view (GET /fleet/booking-events/calendar).
 */
export function useRemoteFetchBookingEventsCalendar(
  params: BookingEventsCalendarParams | null
): UseQueryResult<VehicleBookingEventDto[], RemoteApiError> {
  const enabled =
    params != null &&
    params.vehicleIds.length > 0 &&
    params.startDate.length > 0 &&
    params.endDate.length > 0;

  return useRemoteQuery<VehicleBookingEventDto[], RemoteApiError>({
    queryKey: [
      "fleet",
      "booking-events",
      "calendar",
      params?.vehicleIds,
      params?.startDate,
      params?.endDate
    ],
    url: "/fleet/booking-events/calendar",
    params: params
      ? {
          vehicleIds: params.vehicleIds.join(","),
          startDate: params.startDate,
          endDate: params.endDate
        }
      : undefined,
    enabled
  });
}
